import { trackEvent } from '@/features/common/helpers/google-analytics';

export async function trackSelectAddressSuggestion(gtag) {
  await trackEvent(gtag, 'select_address_suggestion', {
    event_category: 'Create Shipment',
    event_label: 'Users select an address from the Google Address suggestions.',
  });
}

export async function trackManualEntryAddress(gtag) {
  await trackEvent(gtag, 'manual_entry_address', {
    event_category: 'Create Shipment',
    event_label: 'Users manually enter their address without selecting from',
  });
}
